export default "__VITE_ASSET__DvKCm4OK__"